import { gql } from '@apollo/client';

export default gql`
  mutation SortDocument(
    $courseId: String!
    $subjectId: String!
    $input: SortDocumentInput!
  ) {
    documents(courseId: $courseId, subjectId: $subjectId, input: $input)
      @rest(
        type: "Document"
        path: "courses/{args.courseId}/subjects/{args.subjectId}/documents/reorder"
        method: "PUT"
      ) {
      NoResponse
    }
  }
`;
